export default __webpack_public_path__ + "media/images/safari-share-icon-1f1e80ad.png";